import React, { ReactNode } from 'react';
import './style.scss';
import { PagePath } from 'constants/pagePath';

export enum labelColor {
  red = 'colorRed',
  gray = 'colorGray',
  black = 'colorBlack',
}

export enum labelSize {
  small = 'sizeSmall',
  medium = 'sizeMedium',
  large = 'sizeLarge',
  extraLarge = 'sizeExtraLarge',
  massive = 'sizeMassive',
}

export enum alignTarget {
  sp = 'sp',
  desktop = 'desktop',
}

export enum alignType {
  center = 'center',
}

type alignInfo = {
  target: alignTarget;
  type: alignType;
};

type DescriptionProps = {
  labelColor?: labelColor;
  labelSize?: labelSize;
  alignInfo?: alignInfo;
  label: ReactNode;
};

type DescriptionAndLinkProps = {
  labelColor?: labelColor;
  labelSize?: labelSize;
  alignInfo?: alignInfo;
  before: string;
  link: string;
  linkText: string;
  after: string;
};

export const Description = (props: DescriptionProps) => {
  const { labelColor, labelSize, alignInfo, label } = props;
  const labelAlign = alignInfo && `align_${alignInfo?.type}_${alignInfo?.target}`;

  return <div className={`description text ${labelColor} ${labelSize} ${labelAlign}`}>{label}</div>;
};

export const DescriptionAndLink = (props: DescriptionAndLinkProps) => {
  const { labelColor, labelSize, alignInfo, before, link, linkText, after } = props;
  const labelAlign = alignInfo && `align_${alignInfo?.type}_${alignInfo?.target}`;

  return (
    <div className={`description text ${labelColor} ${labelSize} ${labelAlign}`}>
      <div>
        {before}
        <a className="checkLabel_labels_link" href={link} target="_blank" rel="noreferrer">
          {linkText}
        </a>
        {after}
      </div>
    </div>
  );
};
